<app-util-visitor-parts-treatment-injection-list-items
                            [visitor]="visitor"
                            [archived]="archived"
                            [limit]="limit"
                            (updateEvent)="update()"
                            #utilVisitorPartsTreatmentInjectionListItems></app-util-visitor-parts-treatment-injection-list-items>